import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import {
  fetchDashboards, fetchDashboard, criarDashboard, removerDashboard,
  adicionarWidget, atualizarWidget, removerWidget, TIPOS_WIDGET,
} from '../../api/dashboards';
import { fetchFiltrosSalvos } from '../../api/filtros';
import WidgetCard from './WidgetCard';
import './Paineis.css';

const WIDGET_FORM_INICIAL = { id: null, tipo: 'sla_cumprimento', titulo: '', largura: 'meia', datIni: '', datFin: '', filtro_salvo_id: '' };

function Paineis() {
  const history = useHistory();
  const [paineis, setPaineis] = useState([]);
  const [ativoId, setAtivoId] = useState(null);
  const [painel, setPainel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mensagem, setMensagem] = useState('');
  const [modoEdicao, setModoEdicao] = useState(false);

  // criação de painel
  const [novoNome, setNovoNome] = useState('');
  const [criando, setCriando] = useState(false);

  // modal de widget
  const [showWidget, setShowWidget] = useState(false);
  const [widgetForm, setWidgetForm] = useState(WIDGET_FORM_INICIAL);
  const [salvandoWidget, setSalvandoWidget] = useState(false);
  const [filtrosSalvos, setFiltrosSalvos] = useState([]);

  const verificar = useCallback(async () => {
    const ok = await verificandoApp('ATENDENTE');
    if (!ok) history.push('/');
  }, [history]);

  const carregarLista = useCallback(async () => {
    verificandoToken();
    setLoading(true);
    const lista = await fetchDashboards();
    setPaineis(lista);
    setAtivoId((prev) => prev || (lista[0] ? lista[0].id : null));
    setLoading(false);
  }, []);

  const carregarPainel = useCallback(async (id) => {
    if (!id) { setPainel(null); return; }
    const p = await fetchDashboard(id);
    setPainel(p);
  }, []);

  useEffect(() => { verificar(); carregarLista(); }, [verificar, carregarLista]);
  useEffect(() => { carregarPainel(ativoId); }, [ativoId, carregarPainel]);
  useEffect(() => { fetchFiltrosSalvos('chamados-abertos').then(setFiltrosSalvos); }, []);

  const criarPainel = async () => {
    if (!novoNome.trim()) { setMensagem('Informe um nome para o painel.'); return; }
    setCriando(true);
    try {
      const res = await criarDashboard({ nome: novoNome.trim() });
      setNovoNome('');
      await carregarLista();
      if (res?.data?.id) { setAtivoId(res.data.id); setModoEdicao(true); }
      setMensagem('');
    } catch (e) {
      setMensagem(e?.response?.data?.error || 'Erro ao criar painel.');
    } finally {
      setCriando(false);
    }
  };

  const excluirPainel = async () => {
    if (!painel || !painel.proprio) return;
    if (!window.confirm(`Excluir o painel "${painel.nome}"?`)) return;
    try {
      await removerDashboard(painel.id);
      setAtivoId(null);
      setPainel(null);
      await carregarLista();
    } catch (e) {
      setMensagem(e?.response?.data?.error || 'Erro ao excluir painel.');
    }
  };

  const abrirNovoWidget = () => { setWidgetForm(WIDGET_FORM_INICIAL); setShowWidget(true); };
  const abrirEditarWidget = (w) => {
    const c = w.config || {};
    setWidgetForm({
      id: w.id, tipo: w.tipo, titulo: w.titulo || '', largura: w.largura || 'meia',
      datIni: c.datIni || '', datFin: c.datFin || '',
      filtro_salvo_id: c.filtro_salvo_id || '',
    });
    setShowWidget(true);
  };

  const montarConfig = () => {
    const meta = TIPOS_WIDGET.find((t) => t.tipo === widgetForm.tipo);
    const config = {};
    if (meta && meta.periodo) {
      if (widgetForm.datIni) config.datIni = widgetForm.datIni;
      if (widgetForm.datFin) config.datFin = widgetForm.datFin;
    }
    if (widgetForm.tipo === 'contador' && widgetForm.filtro_salvo_id) {
      const f = filtrosSalvos.find((x) => String(x.id) === String(widgetForm.filtro_salvo_id));
      config.filtro_salvo_id = widgetForm.filtro_salvo_id;
      if (f && f.definicao) config.definicao = f.definicao;
    }
    return config;
  };

  const salvarWidget = async () => {
    if (!painel) return;
    setSalvandoWidget(true);
    try {
      const body = {
        tipo: widgetForm.tipo,
        titulo: widgetForm.titulo,
        largura: widgetForm.largura,
        config: montarConfig(),
      };
      if (widgetForm.id) await atualizarWidget(painel.id, widgetForm.id, body);
      else await adicionarWidget(painel.id, body);
      setShowWidget(false);
      await carregarPainel(painel.id);
    } catch (e) {
      setMensagem(e?.response?.data?.error || 'Erro ao salvar widget.');
    } finally {
      setSalvandoWidget(false);
    }
  };

  const excluirWidget = async (w) => {
    if (!painel) return;
    if (!window.confirm('Remover este widget?')) return;
    try {
      await removerWidget(painel.id, w.id);
      await carregarPainel(painel.id);
    } catch (e) {
      setMensagem(e?.response?.data?.error || 'Erro ao remover widget.');
    }
  };

  const metaTipo = TIPOS_WIDGET.find((t) => t.tipo === widgetForm.tipo);

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content paineis-page">
        <div className="paineis-header">
          <div>
            <h3 className="mb-0"><i className="fas fa-th-large me-2" />Painéis</h3>
            <p className="text-muted mb-0">Monte painéis de métricas com os widgets disponíveis.</p>
          </div>
          <div className="paineis-novo">
            <input
              type="text" className="form-control form-control-sm" placeholder="Novo painel…"
              value={novoNome} onChange={(e) => setNovoNome(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') criarPainel(); }}
              maxLength={120}
            />
            <button type="button" className="btn btn-primary btn-sm" onClick={criarPainel} disabled={criando}>
              <i className="fas fa-plus me-1" />Criar
            </button>
          </div>
        </div>

        {mensagem && <div className="alert alert-warning py-2">{mensagem}</div>}

        {loading ? (
          <p className="text-muted">Carregando…</p>
        ) : paineis.length === 0 ? (
          <div className="paineis-vazio">
            <i className="fas fa-th-large" />
            <p>Nenhum painel ainda. Crie o primeiro acima.</p>
          </div>
        ) : (
          <>
            <div className="paineis-tabs">
              {paineis.map((p) => (
                <button
                  key={p.id} type="button"
                  className={`paineis-tab ${String(p.id) === String(ativoId) ? 'ativo' : ''}`}
                  onClick={() => setAtivoId(p.id)}
                >
                  {p.nome}{p.compartilhado && !p.proprio ? ' 👥' : ''}
                </button>
              ))}
            </div>

            {painel && (
              <div className="paineis-toolbar">
                <span className="text-muted small">{(painel.widgets || []).length} widget(s)</span>
                <div className="paineis-toolbar-acoes">
                  {painel.proprio && (
                    <>
                      <button type="button" className={`btn btn-sm ${modoEdicao ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => setModoEdicao((v) => !v)}>
                        <i className="fas fa-pen me-1" />{modoEdicao ? 'Concluir edição' : 'Editar'}
                      </button>
                      {modoEdicao && (
                        <button type="button" className="btn btn-primary btn-sm" onClick={abrirNovoWidget}>
                          <i className="fas fa-plus me-1" />Adicionar widget
                        </button>
                      )}
                      {modoEdicao && (
                        <button type="button" className="btn btn-outline-danger btn-sm" onClick={excluirPainel}>
                          <i className="fas fa-trash me-1" />Excluir painel
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}

            {painel && (
              <div className="paineis-grid">
                {(painel.widgets || []).length === 0 ? (
                  <div className="paineis-vazio">
                    <i className="fas fa-chart-pie" />
                    <p>Painel sem widgets. {painel.proprio ? 'Entre em "Editar" e adicione widgets.' : ''}</p>
                  </div>
                ) : (
                  (painel.widgets || []).map((w) => (
                    <WidgetCard
                      key={w.id} widget={w}
                      modoEdicao={modoEdicao && painel.proprio}
                      onEditar={abrirEditarWidget} onRemover={excluirWidget}
                    />
                  ))
                )}
              </div>
            )}
          </>
        )}

        {showWidget && (
          <div className="paineis-modal-overlay" onClick={() => setShowWidget(false)}>
            <div className="paineis-modal" onClick={(e) => e.stopPropagation()}>
              <h5>{widgetForm.id ? 'Editar widget' : 'Adicionar widget'}</h5>

              <div className="form-group mb-2">
                <label>Tipo</label>
                <select className="form-control form-control-sm" value={widgetForm.tipo}
                  onChange={(e) => setWidgetForm((f) => ({ ...f, tipo: e.target.value }))} disabled={!!widgetForm.id}>
                  {TIPOS_WIDGET.map((t) => <option key={t.tipo} value={t.tipo}>{t.nome}</option>)}
                </select>
              </div>

              <div className="form-group mb-2">
                <label>Título (opcional)</label>
                <input type="text" className="form-control form-control-sm" value={widgetForm.titulo}
                  onChange={(e) => setWidgetForm((f) => ({ ...f, titulo: e.target.value }))} maxLength={120} />
              </div>

              {metaTipo && metaTipo.periodo && (
                <div className="row">
                  <div className="col-6 form-group mb-2">
                    <label>De (opcional)</label>
                    <input type="date" className="form-control form-control-sm" value={widgetForm.datIni}
                      onChange={(e) => setWidgetForm((f) => ({ ...f, datIni: e.target.value }))} />
                  </div>
                  <div className="col-6 form-group mb-2">
                    <label>Até (opcional)</label>
                    <input type="date" className="form-control form-control-sm" value={widgetForm.datFin}
                      onChange={(e) => setWidgetForm((f) => ({ ...f, datFin: e.target.value }))} />
                  </div>
                  <small className="text-muted px-2">Em branco = últimos 30 dias.</small>
                </div>
              )}

              {widgetForm.tipo === 'contador' && (
                <div className="form-group mb-2">
                  <label>Filtro salvo</label>
                  <select className="form-control form-control-sm" value={widgetForm.filtro_salvo_id}
                    onChange={(e) => setWidgetForm((f) => ({ ...f, filtro_salvo_id: e.target.value }))}>
                    <option value="">Todos os chamados em aberto</option>
                    {filtrosSalvos.map((f) => <option key={f.id} value={f.id}>{f.nome}</option>)}
                  </select>
                </div>
              )}

              <div className="form-group mb-3">
                <label>Largura</label>
                <select className="form-control form-control-sm" value={widgetForm.largura}
                  onChange={(e) => setWidgetForm((f) => ({ ...f, largura: e.target.value }))}>
                  <option value="meia">Meia largura</option>
                  <option value="inteira">Largura inteira</option>
                </select>
              </div>

              <div className="paineis-modal-acoes">
                <button type="button" className="btn btn-link btn-sm" onClick={() => setShowWidget(false)}>Cancelar</button>
                <button type="button" className="btn btn-primary btn-sm" onClick={salvarWidget} disabled={salvandoWidget}>
                  {salvandoWidget ? 'Salvando…' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default Paineis;
